<template>
   <HeaderDash />
   <SideMenu /> 
   <ContentWeekly /> 
</template>

<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/manager/dashboard/HeaderDash.vue'
import SideMenu from '@/components/manager/dashboard/SideMenu.vue'
import ContentWeekly from '@/components/manager/dashboard/modules/report/weekly/ContentWeekly.vue'

export default 
{
  name: 'Weekly',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentWeekly
  }
}
</script>

<style>


</style>